"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var InfoModal = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0 30px 30px 30px;\n  width: calc(100vw - 80px);\n  max-width: 600px;\n  font-family: var(--font-sans);\n  color: var(--color-text-black);\n  font-size: 12px;\n  line-height: 22px;\n  letter-spacing: 0;\n  font-weight: 300;\n"])));

var Title = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: var(--font-sans);\n  color: var(--color-text-black);\n  font-size: 16px;\n  font-weight: 500;\n  padding: 20px 0;\n  width: 100%;\n  background: #f2f2f2;\n  text-align: center;\n  letter-spacing: 2.88px;\n  line-height: 24px;\n  border-bottom: 1px solid #9b9b9b;\n"])));

var _default = {
  InfoModal: InfoModal,
  Title: Title
};
exports.default = _default;